<div class=" filter-wrapper">
    <div class="drop-down-wrapper">
        <div class="drop-button-wrapper" (click)="setOpenPopup('type')" id="benefitsTypeTrigger">
            <div id="benefitsTypeDropdown" class="drop-down" [ngClass]="openPopup == 'type' ? 'open' : null" (click)="$event.stopPropagation()">
                <div  class="main-title-mobile" [ngStyle]="{background: data?.image?.url ? 'url(' + data.image.url + ')no-repeat' : null}">
                    <h2 class="drop-down-label">בחירת תחום</h2>
                    <span class="close-drop" (click)="setOpenPopup('type')"></span>
                </div>
                <span class="category-title option" (click)="filterByType(null)">כל התחומים</span>
                <ul>
                    <li class="option" *ngFor="let type of data?.types" (click)="filterByType(type)"><a title="">{{type.typeName}}</a></li>
                </ul>
            </div>
            <div class="title">{{benefitsSvc.type?.typeName || 'תחום'}}</div>
        </div>
        <div class="drop-button-wrapper" (click)="setOpenPopup('region')" id="benefitsRegionTrigger">
            <div id="benefitsRegionDropdown" class="drop-down" [ngClass]="openPopup == 'region' ? 'open' : null" (click)="$event.stopPropagation()">
                <div class="main-title-mobile" [ngStyle]="{background: data?.image?.url ? 'url(' + data.image.url + ')no-repeat' : null}">
                    <h2 class="drop-down-label">בחירת אזור</h2>
                    <span class="close-drop" (click)="setOpenPopup('region')"></span>
                </div>
                <span class="category-title option" (click)="filterByRegion(null)">כל האזורים</span>
                <ul>
                    <li class="option" *ngFor="let region of data?.regions" (click)="filterByRegion(region)"><a title="">{{region.name}}</a></li>
                </ul>
            </div>
            <div class="title">{{benefitsSvc.region?.name || 'אזור'}}</div>
        </div>
        <div class="drop-button-wrapper last" (click)="setOpenPopup('sort')" id="benefitsSortTrigger">
            <div id="benefitsSortDropdown" class="drop-down" [ngClass]="openPopup == 'sort' ? 'open' : null" (click)="$event.stopPropagation()">
                <div class="main-title-mobile" [ngStyle]="{background: data?.image?.url ? 'url(' + data.image.url + ')no-repeat' : null}">
                    <h2 class="drop-down-label">בחירת מיון</h2>
                    <span class="close-drop" (click)="setOpenPopup('sort')"></span>
                </div>
                <span class="category-title option" (click)="sortBenefits(null); sortText = 'מהחדש לישן'">מהחדש לישן</span>
                <ul>
                    <li class="option" (click)="sortBenefits('percent'); sortText = 'אחוז הנחה'"><a title="">אחוז הנחה</a></li>
                    <li class="option" (click)="sortBenefits('name'); sortText = 'שם בית עסק א\'-ת\''"><a title="">שם בית עסק א'-ת'</a></li>
                </ul>
            </div>
            <div class="title">{{sortText || 'מיין לפי'}}</div>
        </div>
    </div>
</div>